import * as React from 'react';
import { SummaryProducer, ShipmentSummary, Summary, createMapData } from '../Models/Report';
import CardSummary from './CardSummary';
import { getColorQuality } from '../Models/Colors';
import { capitalize } from '../Utils/StrUtil';
import History from './History';
import { EReport } from '../Actions/Report/Actions';

export interface ISummaryBranchProps {
	selected: SummaryProducer;
	selectedBranch: number;
	shipmentData: ShipmentSummary;
	loading: boolean;
	report: string;
	reportType: EReport;
}

export interface IHeaderSummaryBranchProps {
	name: string;
}

export const HeaderSummaryBranch =(props: IHeaderSummaryBranchProps) => (<div>
	<h1>Resumen del estado de la faena {capitalize(props.name)}</h1>
	<p>Estatus del cobre en Puerto Angamos</p>
</div>)

const SummaryBranch = (props: ISummaryBranchProps) => {
	const branch = props.selected.branchs.find(b => b.id === props.selectedBranch);
	const qualities: Summary[] = branch ? branch!.qualities.map((q: Summary, index: number) => {
		q.color = getColorQuality(index);
		return q;
	}) : [];
	return <div>

		<div>
			<CardSummary loading={false} data={qualities} titleGraph={`Calidad del cobre ${branch ? branch.name : ''}`} titleItem="Calidad del cobre según faena" />
		</div>
		<div>
			<History reportType={props.reportType} report={props.report} data={createMapData(branch ? branch!.list :  [], props.reportType)}  />
		</div>
	</div>
}

export default SummaryBranch;
